// extracted by mini-css-extract-plugin
export default {"appendix":"FilesInController_appendix__i2BI0","listedFile":"FilesInController_listedFile__DtiIO"};